import React from 'react';
import { motion } from 'framer-motion';
import { animationParams, animationVariants } from 'fragments';
import { RevenueCard } from './revenueCard';
import { revenueCardsData } from '../constants';

export const RevenueManagement = () => {
    return (
        <div className="revenue-management-features-wrapper">
            <div className="container">
                <div className="revenue-management-features-block">
                    <div className="revenue-management-flag">Revenue Cycle Management (RCM)</div>
                    <div style={{ overflow: 'hidden' }}>
                        <motion.h2 className="revenue-management-title" {...animationParams} variants={animationVariants.titleVariant}>
                            Smarter billing, fewer denials, and faster reimbursements{' '}
                            <span style={{ color: '#16A34A' }}> - all handled for you!</span>
                        </motion.h2>
                    </div>

                    <div style={{ overflow: 'hidden' }}>
                        <motion.p className="revenue-management-text" {...animationParams} variants={animationVariants.titleVariantMobile}>
                            TherapyLake’s billing experts ensure your claims are clean, accurate, and submitted on time so your team can
                            stay focused on client care
                        </motion.p>
                    </div>

                    <div className="revenue-management-cards-wrapper">
                        {revenueCardsData.map((card, index) => (
                            <RevenueCard {...card} key={index} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};
